import { FaAward } from "react-icons/fa";
import HeroSection from "../../../../ReusableComponent/HeroSection"

const CertificateHeroSection = () => {
  const stats = [
    { value: "100+", label: "Technologies" },
    { value: "500K+", label: "Certificates Issued" },
    { value: "95%", label: "Employer Recognition" },
    { value: "4.8", label: "Average Rating" },
  ];

  return (
    <HeroSection
      title="Skills Certification"
      subtitle="Validate your expertise with industry-recognized certificates"
      icon={<FaAward />}
      stats={stats}
    />
  );
}

export default CertificateHeroSection;